<div *ngIf="tableContent && tableContent.data && tableContent.columns && tableContent.data.length > 1"
  class="col-12 flex mt-4" style="overflow: scroll;">
  <p-table [value]="tableContent.data" [resizableColumns]="true" [scrollable]="true" scrollHeight="400px"
    styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '20rem' }">
    <ng-template pTemplate="caption">
      <div class="flex justify-content-start">
        <p-button type="button" label="Export to Excel" icon="pi pi-file-excel" 
          (click)="exportExcel()" severity="help" pTooltip="Export to Excel"></p-button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Actions</th>
        <th *ngFor="let col of tableContent.columns">{{col.header}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td>
          <!-- Add View button if promoPlanId exists in the row data -->
          <p-button icon="pi pi-window-maximize" [rounded]="true" [text]="true" severity="info"
            (click)="onViewDetails(rowData)" pTooltip="Show details in the canvas" />
        </td>
        <td *ngFor="let col of tableContent.columns">
          <ng-container *ngIf="isDateArray(rowData[col.field]); else defaultCell">
            {{ arrayToDate(rowData[col.field]) | date:'dd-MM-yyyy' }}
          </ng-container>
          <ng-template #defaultCell>
            {{ rowData[col.field] }}
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>